const INTERCOM_API_BASE = "https://api-iam.intercom.io";

/** Unset means no Messenger on this build, which is how we keep it off local and staging. */
export const getIntercomAppId = (): string | null => {
  return process.env.REACT_APP_INTERCOM_APP_ID || null;
};

const getIntercom = () => {
  const win = window as any;
  return typeof win.Intercom === "function" ? win.Intercom : null;
};

/** Install Intercom's command queue and widget script. Safe to call repeatedly. */
export const loadIntercomWidget = (appId: string) => {
  if (getIntercom()) {
    return;
  }

  const win = window as any;
  const stub: any = function (...args: any[]) {
    stub.c(args);
  };
  stub.q = [];
  stub.c = (args: any[]) => {
    stub.q.push(args);
  };
  win.Intercom = stub;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://widget.intercom.io/widget/${appId}`;
  document.head.appendChild(script);
};

/**
 * Visitors only. This app sends no signed identity token, so chats land in the Intercom
 * Inbox as leads and Bea asks for an email before handing off to the team. Identifying a
 * logged-in member requires a JWT from the Next app, which lives on beautista.com.
 */
export const bootIntercom = (appId: string) => {
  const intercom = getIntercom();
  if (intercom) {
    intercom("boot", { api_base: INTERCOM_API_BASE, app_id: appId });
  }
};

export const updateIntercom = (settings?: Record<string, unknown>) => {
  const intercom = getIntercom();
  if (intercom) {
    intercom("update", settings);
  }
};

/** Clears the Messenger session so the next person on a shared browser starts fresh. */
export const shutdownIntercom = () => {
  const intercom = getIntercom();
  if (intercom) {
    intercom("shutdown");
  }
};
